import {
  Box,
  FormControl,
  FormControlLabel,
  ListItem,
  Radio,
  RadioGroup,
} from "@mui/material";
import { SmartAutoComplete, SmartDatePicker } from "@nodeon/react-components";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ActionType } from "~/api/GeneratedApi";
import { useDropdownOptions } from "../hooks/useDropdownOptions";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type ActionFormDefaultTypes = {
  actionTypes: ActionType[] | null;
  actionStartDate: Date | null;
  actionEndDate: Date | null;

  actionDone: boolean;
};

export const actionFormDefaultValues: ActionFormDefaultTypes = {
  actionTypes: null,
  actionStartDate: null,
  actionEndDate: null,
  actionDone: true,
};

export const ActionsForm = ({ isDisabled }: SharedFormProps) => {
  const { t } = useTranslation("fairwayReport");
  const { control } = useFormContext<ActionFormDefaultTypes>();
  const { searchResult, isLoading } = useDropdownOptions();

  return (
    <Box
      sx={{
        display: "grid",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <Typography>{t("fairwayReport:deviceIdOrName")}</Typography> */}
      <SmartAutoComplete<ActionFormDefaultTypes, ActionType[], false>
        disabled={isDisabled}
        name="actionTypes"
        label={t("actionSearch:actionType")}
        options={(searchResult?.actionTypes as ActionType[][]) ?? []}
        controllerProps={{ control }}
        getOptionLabel={([ac]) => ac.codE_NME ?? ""}
        // eslint-disable-next-line @typescript-eslint/no-shadow
        isOptionEqualToValue={(actions, options) =>
          actions.some((a) =>
            options.some((o) => o.actioN_CDE === a.actioN_CDE),
          )
        }
        loading={isLoading}
        renderOption={(props, params) => (
          <ListItem
            {...props}
            key={`${params[0].actioN_CDE}-${params[0].codE_NME}`}
          >
            {params[0].codE_NME}
          </ListItem>
        )}
      />
      <Box
        sx={{
          display: "grid",
          gap: "10px",
          gridTemplateColumns: "1fr 1fr",
        }}
      >
        <SmartDatePicker<ActionFormDefaultTypes>
          disabled={isDisabled}
          controllerProps={{ control }}
          name="actionStartDate"
          label={t("vessels:startTime")}
        />

        <SmartDatePicker<ActionFormDefaultTypes>
          disabled={isDisabled}
          controllerProps={{ control }}
          name="actionEndDate"
          label={t("vessels:endTime")}
        />
      </Box>
      <FormControl disabled={isDisabled}>
        <Controller<ActionFormDefaultTypes>
          name="actionDone"
          control={control}
          render={({ field }) => (
            <RadioGroup
              sx={{
                display: "flex",
                flexDirection: "row",
                mt: "5px",
                width: "100%",
              }}
              {...field}
              onChange={(_e, value) => field.onChange(value === "true")}
            >
              <FormControlLabel
                name="condition"
                value="true"
                control={<Radio />}
                label={t("fairwayReport:actionDone")}
              />
              <FormControlLabel
                name="condition"
                value="false"
                control={<Radio />}
                label={t("fairwayReport:actionNotDone")}
              />
            </RadioGroup>
          )}
        />
      </FormControl>
      {/* <SmartAutoComplete<SearchFormData, ActionType, false>
        disabled={isDisabled}
        name="actionNotDoneInInterval"
        label={t("actionNotDoneInTheInterval")}
        options={searchResult?.actionTypes ?? []}
        controllerProps={{ control }}
        getOptionLabel={({ codE_NME }) => codE_NME ?? ""}
        isOptionEqualToValue={({ actioN_TYPE_CDE }, options) =>
          actioN_TYPE_CDE === options.actioN_TYPE_CDE
        }
        renderOption={(props, params) => (
          <ListItem
            {...props}
            key={`${params.actioN_TYPE_CDE}-${params.codE_NME}`}
          >
            {params.codE_NME}
          </ListItem>
        )}
      />
      <Box
        sx={{
          display: "grid",
          gap: "10px",
          gridTemplateColumns: "1fr 1fr",
        }}
      >
        <SmartDatePicker<SearchFormData>
          disabled={isDisabled}
          controllerProps={{ control }}
          name="actionNotDoneStartDate"
          label={t("vessels:startTime")}
        />

        <SmartDatePicker<SearchFormData>
          disabled={isDisabled}
          controllerProps={{ control }}
          name="actionNotDoneEndDate"
          label={t("vessels:endTime")}
        />
      </Box> */}
    </Box>
  );
};
